import { Container, Stack } from '@mui/material';
import { SideBarFilter } from '../components';
import useReportGenerateState from '../hooks/useReportGenerateState';
import { useAuthentication } from 'src/features/authentication/context';
import { useTemplateState } from '../context/templateContext';
import ReportsNewForm from './ReportsNewForm';
import { useOutletContext } from 'react-router';
import { ReportType } from '../types';
import { useResponsive } from 'src/hooks/useResponsive';
import { useFilters } from '../hooks/useFilters';

type OutletContextType = {
  title: string;
  disableHeaderFormBuilder: boolean;
  reportType: string;
  disableActions: boolean;
  setDisableActions: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AssetReportsPage = () => {
  const { title, disableHeaderFormBuilder, disableActions, setDisableActions } =
    useOutletContext<OutletContextType>();
  const isTablet = useResponsive('down', 'lg');
  const { handleReportsGenerate } = useReportGenerateState({
    setDisableActions,
  });
  const { undoChanges } = useTemplateState();

  const {
    isOpen,
    toggleSidebar,
    applyFiltersHandler,
    appliedFilters,
    isFilterBtnActive,
    clearAllFiltersHandler,
    isInitialState,
  } = useFilters();
  const { sites } = useAuthentication();

  return (
    <Container
      maxWidth={false}
      disableGutters
      data-testId="reports-page"
      sx={{ paddingBottom: '1rem' }}
    >
      <SideBarFilter
        isOpen={isOpen}
        isInitialState={isInitialState}
        sites={sites}
        toggleSidebar={toggleSidebar}
        applyFiltersHandler={applyFiltersHandler}
        appliedFilters={appliedFilters}
      />
      <Stack
        flexDirection={isTablet ? 'column' : 'row'}
        gap="24px"
        flex="1"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        {!disableHeaderFormBuilder && (
          <ReportsNewForm
            applyFiltersHandler={applyFiltersHandler}
            toggleSidebar={toggleSidebar}
            onSubmit={handleReportsGenerate}
            isFilterBtnActive={isFilterBtnActive}
            clearAllFiltersHandler={clearAllFiltersHandler}
            title={title}
            disableActions={disableActions}
            onUndo={undoChanges}
            reportType={ReportType.ASSET}
          />
        )}
      </Stack>
    </Container>
  );
};
